export const dateKey = (d = new Date()) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
export function deadline(months, now = new Date()) {
  const d = new Date(now); const day = d.getDate();
  d.setDate(1); d.setMonth(d.getMonth()+Number(months));
  d.setDate(Math.min(day, new Date(d.getFullYear(),d.getMonth()+1,0).getDate()));
  return dateKey(d);
}
export function plan(goal, today = dateKey()) {
  const saved = Number(goal.initial || 0) + goal.entries.reduce((s,e)=>s+e.amount,0);
  const remaining = Math.max(0, Math.round((goal.price-saved)*100)/100);
  const days = goal.due ? Math.round((Date.parse(goal.due)-Date.parse(today))/86400000) : 0;
  const periods = Math.max(1,Math.ceil(days/30));
  return {saved, remaining, days, monthly: goal.due ? Math.ceil(remaining/periods*100)/100 : 0, daily: goal.due ? Math.ceil(remaining/Math.max(1,days)*100)/100 : 0, percent: goal.price > 0 ? Math.max(0,Math.min(100,saved/goal.price*100)) : 0};
}
